<template>
  <div class="cloud-personnelAttendance">
    <div class="cloud-personnelAttendance-l">
      <div class="cloud-personnelAttendance-item-1">
        <div class="cloud-personnelAttendance-item-1-c">
          <img
            src="@/assets/images/personnelAttendance_1.png"
            alt=""
            style="width: 100%; height: 100%"
          />
          <div class="cloud-personnelAttendance-item-1-c-content">
            <img src="@/assets/images/personnelAttendance_3.png" alt="" />
            <div>
              <p>
                <em class="emFontStyle">{{ fromData.totalNumber }}</em>
                <span>辆</span>
              </p>
              <p>在册车辆总数</p>
            </div>
          </div>
        </div>
        <div class="cloud-personnelAttendance-item-1-c">
          <img
            src="@/assets/images/personnelAttendance_1.png"
            alt=""
            style="width: 100%; height: 100%"
          />
          <div class="cloud-personnelAttendance-item-1-c-content">
            <img src="@/assets/images/personnelAttendance_4.png" alt="" />
            <div>
              <p>
                <em class="emFontStyle">{{ fromData.holeNumber }}</em>
                <span>辆</span>
              </p>
              <p>现场车辆总数</p>
            </div>
          </div>
        </div>
        <div class="cloud-personnelAttendance-item-1-c">
          <img
            src="@/assets/images/personnelAttendance_1.png"
            alt=""
            style="width: 100%; height: 100%"
          />
          <div class="cloud-personnelAttendance-item-1-c-content">
            <img src="@/assets/images/personnelAttendance_5.png" alt="" />
            <div>
              <p>
                <em class="emFontStyle">{{ fromData.dayNumber }}</em>
                <span>辆</span>
              </p>
              <p>今日出勤车辆总数</p>
            </div>
          </div>
        </div>
      </div>

      <div class="cloud-personnelAttendance-item-2">
        <div style="width: 38%; height: 43vh; float: left; position: relative">
          <div class="cloud-personnelAttendance-title" style="width: 100%">
            <div class="cloud-personnelAttendance-title-title">
              <img src="@/assets/images/groupTitle.png" alt="" />
              <p>门禁考勤</p>
              <dv-decoration-3
                class="decoration-container"
                :style="{ width: '10%', height: '30px' }"
                style="position: absolute; top: 1px; margin-left: 86%"
              >
                <!-- 插槽中添加多个小方块 -->
                <div slot="content" class="squares-container">
                  <div class="square s1"></div>
                  <div class="square s2"></div>
                  <div class="square s3"></div>
                  <div class="square s4"></div>
                  <div class="square s5"></div>
                  <div class="square s6"></div>
                </div>
              </dv-decoration-3>
            </div>
            <div class="cloud-personnelAttendance-title-content">
              <div class="cloud-personnelAttendance-title-content-image">
                <img
                  src="@/assets/images/personnelAttendance_2.png"
                  alt=""
                  style="width: 100%; height: 100%"
                />
                <img
                  src="@/assets/images/ScreenShot2.png"
                  alt=""
                  style="
                    width: 60%;
                    height: 85%;
                    position: absolute;
                    top: 8%;
                    left: 20%;
                  "
                />
              </div>
              <div class="cloud-personnelAttendance-title-content-content">
                <div>
                  <p>车牌号码</p>
                  <p>{{ carWorkerData[num]?.name || "--" }}</p>
                </div>
                <div>
                  <p>班组名称</p>
                  <p>{{ carWorkerData[num]?.department || "--" }}</p>
                </div>
                <div>
                  <p>打卡时间</p>
                  <p>{{ carWorkerData[num]?.dateTime || "--" }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style="
            width: 59%;
            height: 43vh;
            float: right;
            position: relative;
            margin-right: 0.7vw;
          "
        >
          <div
            class="cloud-personnelAttendance-title"
            style="width: 100%; height: 21vh"
          >
            <div class="cloud-personnelAttendance-title-title">
              <img
                src="@/assets/images/groupTitle.png"
                alt=""
                style="width: 75%"
              />
              <p>现场车辆</p>
              <dv-decoration-3
                class="decoration-container"
                :style="{ width: '6%', height: '30px' }"
                style="position: absolute; top: 1px; margin-left: 92%"
              >
                <!-- 插槽中添加多个小方块 -->
                <div slot="content" class="squares-container">
                  <div class="square s1"></div>
                  <div class="square s2"></div>
                  <div class="square s3"></div>
                  <div class="square s4"></div>
                  <div class="square s5"></div>
                  <div class="square s6"></div>
                </div>
              </dv-decoration-3>
            </div>
            <div class="cloud-personnelAttendance-title-content">
              <ul class="cloud-personnelAttendance-title-content-ul">
                <li
                  v-for="(item, index) in groupsAttendanceDayListData"
                  :key="index"
                >
                  <p>{{ item.name }}</p>
                  <p>
                    <el-progress
                      :percentage="handlePercentage(item.value)"
                      color="#5fb0f3"
                      :stroke-width="12"
                      text-color="#fff"
                      define-back-color="#09419b"
                    ></el-progress>
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div
            class="cloud-personnelAttendance-title"
            style="
              width: 100%;
              height: 21vh;
              margin-top: calc(242 / 1080 * 100vh);
            "
          >
            <div class="cloud-personnelAttendance-title-title">
              <img
                src="@/assets/images/groupTitle.png"
                alt=""
                style="width: 75%"
              />
              <p>考勤车辆</p>
              <dv-decoration-3
                class="decoration-container"
                :style="{ width: '6%', height: '30px' }"
                style="position: absolute; top: 1px; margin-left: 92%"
              >
                <!-- 插槽中添加多个小方块 -->
                <div slot="content" class="squares-container">
                  <div class="square s1"></div>
                  <div class="square s2"></div>
                  <div class="square s3"></div>
                  <div class="square s4"></div>
                  <div class="square s5"></div>
                  <div class="square s6"></div>
                </div>
              </dv-decoration-3>
            </div>
            <div class="cloud-personnelAttendance-title-content">
              <ul class="cloud-personnelAttendance-title-content-ul">
                <li v-for="(item, index) in groupsListData" :key="index">
                  <p>{{ item.name }}</p>
                  <p>
                    <el-progress
                      :percentage="handlePercentage(item.value)"
                      color="#5fb0f3"
                      :stroke-width="12"
                      text-color="#fff"
                      define-back-color="#09419b"
                    ></el-progress>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="cloud-personnelAttendance-item-3">
        <div
          class="cloud-personnelAttendance-title"
          style="width: 100%; height: 27vh"
        >
          <div class="cloud-personnelAttendance-title-title">
            <img
              src="@/assets/images/groupTitle.png"
              alt=""
              style="width: 45%"
            />
            <p>最近一周出勤车辆</p>
            <dv-decoration-3
              class="decoration-container"
              :style="{ width: '4%', height: '30px' }"
              style="position: absolute; top: 1px; margin-left: 95%"
            >
              <!-- 插槽中添加多个小方块 -->
              <div slot="content" class="squares-container">
                <div class="square s1"></div>
                <div class="square s2"></div>
                <div class="square s3"></div>
                <div class="square s4"></div>
                <div class="square s5"></div>
                <div class="square s6"></div>
              </div>
            </dv-decoration-3>
          </div>
          <div class="cloud-personnelAttendance-title-content">
            <div
              id="main_PersonnelAttendance"
              class="chart-container"
              style="width: 100%; height: 28vh"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="cloud-personnelAttendance-r">
      <div
        class="cloud-personnelAttendance-title"
        style="width: 100%; height: 85vh"
      >
        <div class="cloud-personnelAttendance-title-title">
          <img src="@/assets/images/groupTitle.png" alt="" style="width: 45%" />
          <p>当日考勤岗列表</p>
          <dv-decoration-3
            class="decoration-container"
            :style="{ width: '3%', height: '30px' }"
            style="position: absolute; top: 1px; margin-left: 96%"
          >
            <!-- 插槽中添加多个小方块 -->
            <div slot="content" class="squares-container">
              <div class="square s1"></div>
              <div class="square s2"></div>
              <div class="square s3"></div>
              <div class="square s4"></div>
              <div class="square s5"></div>
              <div class="square s6"></div>
            </div>
          </dv-decoration-3>
        </div>
        <div
          class="cloud-personnelAttendance-title-content"
          style="overflow-y: hidden"
        >
          <div class="cloud-personnelAttendance-title-content-table">
            <p>车牌号码</p>
            <p>班组</p>
            <p>录入时间</p>
            <p>记录状态</p>
          </div>
          <div
            style="
              width: 100%;
              height: 90vh;
              overflow-y: auto;
              scrollbar-width: thin;
              scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
            "
          >
            <div
              class="cloud-personnelAttendance-title-content-table"
              v-for="(item, index) in carWorkerData"
              :key="index"
              @click="handleClick(item, index)"
              style="cursor: pointer"
            >
              <p>{{ item.name }}</p>
              <p>{{ item.department }}</p>
              <p>{{ formatTimeHM(item.dateTime) }}</p>
              <p>{{ item.status }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  axisLine,
  lastSevenDayData,
  formatTimeHM,
  getDay,
  handlePercentage,
} from "@/utils/index.js";
import {
  carList,
  carAttendanceList,
  getStatisticsOfCarInTunnel,
  getStatisticsOfCarAtt,
  getStatisticsOfCarAttCountWeek,
  carAttendance,
} from "@/public/api.js";
import * as echarts from "echarts";
import { StatisticsData, workerData, ListData } from "./carAttendanceData.js";

// 引入路由实例
export default {
  name: "personnelAttendance",
  components: {},
  data() {
    return {
      myChart_Personnel: null,
      form: {
        date: getDay(),
        // tunnelNumber: null,
        itemId: "",
      },
      groupsListData: [],
      groupsAttendanceDayListData: [],
      lastSevenDays: lastSevenDayData(), // 新增最近七天的日期数组
      enrollment: 0, //注册人数
      carWorkerData: [], // 出勤人数据
      fromData: {
        totalNumber: 0, // 隧道总人数
        dayNumber: 0, // 当日出勤人数
        holeNumber: 0, // 当前洞内人数
      },
      interval: null, // 定时器
      num: 0, // 出勤人索引
      hostName: window.location.hostname,
    };
  },
  computed: {},
  mounted() {
    let that = this;
    that.TunnelsData = JSON.parse(localStorage.getItem("updateLhTunnels"));
    this.form.itemId = that.TunnelsData.itemId;
    // 初始化图表
    this.myChart_Personnel = echarts.init(
      document.getElementById("main_PersonnelAttendance")
    );
    this.axisLineCqrs();
    // 监听窗口大小变化，自动调整图表
    window.addEventListener("resize", this.handleResize);
    // that.interval = setInterval(() => {
    that.getCarAttendance();
    that.getPersonnelAttendance();
    that.carAttendanceList();
    that.getStatisticsOfPersonnelInTunnels();
    that.getStatisticsOfPersonnelAtts();
    that.getStatisticsOfPersonnelAttCountWeeks();
    // },5000)
  },
  methods: {
    handlePercentage,
    formatTimeHM,
    // 获取出勤人数
    getPersonnelAttendance() {
      let that = this;
      if (
        that.hostName == "127.0.0.1" ||
        that.hostName == "39.100.79.198" ||
        that.hostName == "sd.yongsixinxi.com"
      ) {
        that.fromData.totalNumber = 11; // 隧道总人数
        that.fromData.dayNumber = 10; // 当日出勤人数
      } else {
        carList({ itemId: that.form.itemId }).then((res) => {
          if (res.data.code == 200) {
            that.fromData.totalNumber = res.data.data.length; // 隧道总人数
          } else {
            console.error(res.message);
          }
        });
      }
    },
    // 获取出勤车辆列表
    carAttendanceList() {
      let that = this;
      if (
        that.hostName == "127.0.0.1" ||
        that.hostName == "39.100.79.198" ||
        that.hostName == "sd.yongsixinxi.com"
      ) {
        that.carWorkerData = ListData();
      } else {
        carAttendanceList(this.form).then((res) => {
          if (res.data.code == 200) {
            let nameFag = true;
            res.data.data.forEach((item) => {
              nameFag = true;
              that.carWorkerData.forEach((items) => {
                if (items.name == item.name) {
                  nameFag = false;
                }
              });

              if (nameFag) {
                that.carWorkerData.push(item);
              }
            });
          }
        });
      }
    },
    // 获取出勤人列表
    getCarAttendance() {
      let that = this;
      carAttendance(this.form).then((res) => {
        if (res.data.code == 200) {
          let nameFag = true;
          res.data.data.forEach((item) => {
            nameFag = true;
            that.workerData.forEach((items) => {
              if (items.name == item.name) {
                nameFag = false;
              }
            });

            if (nameFag) {
              that.workerData.push(item);
            }
          });
        }
      });
    },
    // 获取统计洞内人员岗位信息
    getStatisticsOfPersonnelInTunnels() {
      let that = this;
      if (
        that.hostName == "127.0.0.1" ||
        that.hostName == "39.100.79.198" ||
        that.hostName == "sd.yongsixinxi.com"
      ) {
        that.groupsAttendanceDayListData = [];
        that.groupsAttendanceDayListData = workerData();
        that.fromData.holeNumber = 10; // 当前洞内人数
      } else {
        getStatisticsOfCarInTunnel({ itemId: that.form.itemId }).then((res) => {
          if (res.data.code == 200) {
            that.groupsAttendanceDayListData = [];
            that.groupsAttendanceDayListData = res.data.data;

            res.data.data.forEach((item) => {
              that.fromData.dayNumber += item.value;
            }); // 当日出勤人数
          }
        });
      }
    },
    // 获取统计当天出勤人员岗位信息
    getStatisticsOfPersonnelAtts() {
      let that = this;
      if (
        that.hostName == "127.0.0.1" ||
        that.hostName == "39.100.79.198" ||
        that.hostName == "sd.yongsixinxi.com"
      ) {
        that.groupsListData = [];
        that.groupsListData = workerData();
      } else {
        getStatisticsOfCarAtt({ itemId: that.form.itemId }).then((res) => {
          if (res.data.code == 200) {
            that.groupsListData = [];
            that.groupsListData = res.data.data;

            res.data.data.forEach((item) => {
              that.fromData.holeNumber += item.value;
            }); // 当前洞内人数
          }
        });
      }
    },
    // 获取统计人员最近七天出勤数量统计
    getStatisticsOfPersonnelAttCountWeeks() {
      let that = this;
      getStatisticsOfCarAttCountWeek({ itemId: that.form.itemId }).then(
        (res) => {
          if (res.data.code == 200) {
            let seriesData = [];
            if (
              that.hostName == "127.0.0.1" ||
              that.hostName == "39.100.79.198" ||
              that.hostName == "sd.yongsixinxi.com"
            ) {
              StatisticsData().forEach((item) => {
                seriesData.push(item.value);
              });
            } else {
              res.data.data.forEach((item) => {
                seriesData.push(item.value);
              });
            }

            that.axisLineCqrs(seriesData);
          }
        }
      );
    },
    axisLineCqrs(seriesDatas) {
      let xAxisData = [];
      for (let i = 6; i >= 0; i--) {
        xAxisData.push(this.lastSevenDays[i].date);
      }

      let legendData = ["出勤人数"];
      let seriesData = [
        {
          name: "出勤人数",
          type: "line",
          stack: "总量",
          itemStyle: {
            normal: { color: "#EE605E", areaStyle: { type: "default" } },
          },
          data: seriesDatas,
        },
      ];
      let option = axisLine(legendData, xAxisData, seriesData);
      this.myChart_Personnel.setOption(option);
    },
    // 窗口大小变化时调整图表
    handleResize() {
      if (this.myChart_Personnel) {
        this.myChart_Personnel.resize();
      }
    },
    // 点击出勤人列表项
    handleClick(item, index) {
      let that = this;
      that.num = index;
    },
  },
  beforeDestroy() {
    // 移除事件监听，销毁图表
    window.removeEventListener("resize", this.handleResize);
    if (this.myChart_Personnel) {
      this.myChart_Personnel.dispose();
    }
  },
  beforeUnmount() {
    // 移除事件监听，销毁图表
    window.removeEventListener("resize", this.handleResize);
    if (this.myChart_Personnel) {
      this.myChart_Personnel.dispose();
    }

    // 离开页面时清除定时器
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
};
</script>
<style scoped>
/* 引入字体 */
@font-face {
  font-family: "DS-Digital";
  src: url("../font/DS-DIGIB.TTF") format("truetype");
  font-weight: normal;
  font-style: normal;
}

.cloud-personnelAttendance {
  width: 100%;
  height: 100%;
  text-align: left;

  > .cloud-personnelAttendance-l {
    position: relative;
    width: 50%;
    height: 86vh;
    left: 1%;
    top: 1vh;
    float: left;
  }

  .cloud-personnelAttendance-item-1 {
    width: 100%;
    height: 12vh;
  }

  .cloud-personnelAttendance-item-1-c {
    width: 32%;
    height: 100%;
    margin: 0px 1% 0px 0px;
    float: left;
    position: relative;
  }

  .cloud-personnelAttendance-item-1-c-content {
    position: absolute;
    top: 15%;
    left: 10%;

    > img {
      width: 60px;
      height: auto;
      float: left;
      border: 1px dashed #4c4c49;
    }

    > div {
      float: left;
      margin: 0px 0px 0px 20px;

      > p {
        margin: 0px;
        padding: 0px;
        width: 100%;
        height: 3vh;
        line-height: 3.5vh;
      }

      > p:nth-child(1) {
        color: #dfef05;
        margin-bottom: 1vh;
      }
    }
  }

  .emFontStyle {
    background: linear-gradient(0deg, #dfef05, #99f313, #cbe90a, #61ddb1);
    font-style: normal;
    background-size: cover;
    font-family: "DS-Digital", electronicFont;
    font-size: 2.5rem;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    text-fill-color: transparent;
  }

  .cloud-personnelAttendance-item-2 {
    width: 100%;
    height: 45vh;
    /* background: rgba(13, 65, 237, 0.434);  */
    border-radius: 10px;
    position: relative;
  }

  .cloud-personnelAttendance-title {
    position: absolute;
    top: 1vh;
    left: 0;
    width: calc(330 / 1920 * 100vw);
    height: calc(470 / 1080 * 100vh);
    background: rgba(0, 0, 0, 0.4);
    border-radius: 10px;

    .cloud-personnelAttendance-title-title {
      position: relative;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 2.5vh;
      margin: 0;
      padding: 0;

      img {
        width: 100%;
        height: auto;
        margin: 0;
        padding: 0;
      }

      p {
        position: absolute;
        top: 0.3vh;
        left: 3.01vh;
        width: 100%;
        height: 2.5vh;
        margin: 0;
        padding: 0;
        font-size: 1rem;
        color: #fff;
        text-align: left;
      }
    }

    .cloud-personnelAttendance-title-content {
      position: relative;
      top: 0px;
      left: 0px;
      width: 100%;
      height: calc(860 / 1080 * 100vh);
      margin: 0;
      padding: 0;
      overflow-y: auto;
      scrollbar-width: thin;
      scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
    }
  }

  .cloud-personnelAttendance-item-3 {
    width: 98.5%;
    height: 28vh;
    border-radius: 10px;
    position: relative;
  }

  .cloud-personnelAttendance-r {
    position: relative;
    width: 48.3%;
    height: 85vh;
    left: 1%;
    top: 0vh;
    /* background-color: #61ddb1; */
    float: left;
  }

  .cloud-personnelAttendance-title-content-image {
    width: 90%;
    height: 22vh;
    margin: 0 auto;
    margin-top: 3vh;
    position: relative;
  }

  .cloud-personnelAttendance-title-content-content {
    width: 100%;
    height: 6.5vh;
    margin: 0 auto;
    margin-top: 1vh;
    position: relative;

    > div {
      width: 90%;
      height: 2.5vh;
      line-height: 2.5vh;
      margin: 0 auto;
      padding: 0px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 0.8rem;
      color: rgba(255, 255, 255, 0.6);
      line-height: 32px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      > p:nth-child(1) {
        width: 25%;
        float: left;
        margin: 0px;
        padding: 0px;
      }

      > p:nth-child(2) {
        width: 65%;
        float: left;
        margin: 0px;
        padding: 0px;
        color: #fff;
      }
    }
  }

  .cloud-personnelAttendance-title-content-ul {
    width: 90%;
    height: 13vh;
    list-style: none;
    margin: 0 auto;
    padding: 0;
    margin-top: 3vh;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(150, 150, 150, 0.2) transparent;

    > li {
      width: 100%;
      height: 3vh;

      > p {
        margin: 0px;
        padding: 0px;

        &:nth-child(1) {
          width: 16%;
          float: left;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 0.8rem;
          color: rgba(255, 255, 255, 0.6);
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        &:nth-child(2) {
          width: 81%;
          float: left;
          padding-top: 0.5vh;
        }
      }
    }
  }

  .cloud-personnelAttendance-title-content-table {
    width: 100%;
    height: 2.5vh;
    margin: 0;
    padding: 0;
    margin-top: 1vh;

    > p {
      height: 2.5vh;
      margin: 0;
      padding: 0;
      float: left;
      line-height: 2.5vh;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 0.8rem;
      color: rgba(255, 255, 255, 0.6);
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    > p:nth-child(1) {
      width: 22%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    > p:nth-child(2) {
      width: 22%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    > p:nth-child(3) {
      width: 15%;
    }

    > p:nth-child(4) {
      width: 15%;
    }

    > p:nth-child(5) {
      width: 20%;
    }
  }

  ::v-deep .el-progress__text {
    font-size: 0.8rem !important;
    margin-left: 20px !important;
    color: #fff;
  }

  /* 图表容器样式 */
  .chart-container {
    width: 100%;
    height: 100%;
    /* 设置最小高度，避免过小 */
    box-sizing: border-box;
    padding: 5px;
    /* 增加内边距，避免内容贴边 */
  }
}
</style>